import type { CampaignLogicAction } from '@coorum-research/shared-common/types'

export function findAlwaysActionIndex(actions: CampaignLogicAction[]): number {
  return actions.findIndex(action => action.condition.op === 'always')
}

/**
 * condition.op === 'always' を一番最後に評価しないといけないので、
 * condition.op === 'always' が最後に配置されてない場合だけ、最後に配置する。
 * 他は優先順位を変更したくないので、そのままにする
 */
export function campaignLogicActionPrioritySort(actions: CampaignLogicAction[]) {
  const sortedActions = [...actions]
  const alwaysActionIndex = findAlwaysActionIndex(actions)

  if (alwaysActionIndex !== -1) {
    sortedActions.splice(alwaysActionIndex, 1)
    sortedActions.push(actions[alwaysActionIndex])
  }

  return sortedActions
}

/**
 * actionのcondition.vars[0].valueが、choiceValuesに含まれる場合
 * その値のindexを優先してソートする。
 */
export function campaignLogicActionChoicePrioritySort(actions: CampaignLogicAction[], choiceValues: string[]) {
  return [...actions].sort((a, b) => {
    // Get the value from the condition vars
    const aValue = a.condition.vars[0]?.value
    const bValue = b.condition.vars[0]?.value

    if (typeof aValue !== 'string' || typeof bValue !== 'string') {
      return 0
    }

    // Find the index of each value in choiceValues
    const aIndex = choiceValues.indexOf(aValue)
    const bIndex = choiceValues.indexOf(bValue)

    // If both values are in choiceValues, sort by their index
    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex
    }

    // If only one value is in choiceValues, prioritize it
    if (aIndex !== -1) {
      return -1
    }

    if (bIndex !== -1) {
      return 1
    }

    // If neither value is in choiceValues, maintain original order
    return 0
  })
}

/**
 * admin clientの条件分岐formで、条件がない時の初期値
 * unitテストの時にも使う
 */
export const initialValueAlwaysActionJson: CampaignLogicAction = {
  action: 'jump',
  condition: {
    op: 'always',
    vars: [],
  },
  detail: {
    to: {
      type: 'default',
      value: '',
    },
  },
}
